export const TrainingBookingCalculator = (bookingData, serviceDetails) => {
  var originalTotal = 0;
  var total = 0;

  // Pull catalog safely
  var trainingPrices = {};
  if (serviceDetails && serviceDetails.training && Array.isArray(serviceDetails.training) && serviceDetails.training.length > 0) {
    var t0 = serviceDetails.training[0];
    if (t0 && t0.additionalPrices) trainingPrices = t0.additionalPrices;
  }

  // Guard selections
  if (!bookingData || !bookingData.trainingOptions) {
    return { originalPrice: 0, discountedPrice: 0 };
  }

  var rawType  = bookingData.trainingOptions.selectedTrainingType || '';
  var rawSess  = bookingData.trainingOptions.selectedSessionType  || '';

  // Normalize keys so "Obedience" and "obedience" map the same
  var typeKey   = String(rawType).toLowerCase().trim();
  var sessionKey= String(rawSess).toLowerCase().trim();

  // Build a lowercased view of the price map (once)
  var lowerPrices = {};
  var k;
  for (k in trainingPrices) {
    if (!Object.prototype.hasOwnProperty.call(trainingPrices, k)) continue;
    var tk = String(k).toLowerCase().trim();
    var inner = trainingPrices[k];
    lowerPrices[tk] = {};
    var s;
    for (s in inner) {
      if (!Object.prototype.hasOwnProperty.call(inner, s)) continue;
      var sk = String(s).toLowerCase().trim();
      lowerPrices[tk][sk] = inner[s];
    }
  }

  // Hard guards to avoid crashes
  if (!typeKey || !sessionKey) {
    return { originalPrice: 0, discountedPrice: 0 };
  }
  if (!lowerPrices[typeKey] || typeof lowerPrices[typeKey] !== 'object') {
    // Uncomment for debugging:
    // console.warn("No prices for type:", typeKey, "available:", Object.keys(lowerPrices));
    return { originalPrice: 0, discountedPrice: 0 };
  }

  var basePrice = 0;
  if (Object.prototype.hasOwnProperty.call(lowerPrices[typeKey], sessionKey)) {
    basePrice = Number(lowerPrices[typeKey][sessionKey]) || 0;
  } else {
    // console.warn("No session price:", sessionKey, "available:", Object.keys(lowerPrices[typeKey]));
    return { originalPrice: 0, discountedPrice: 0 };
  }

  originalTotal += basePrice;
  total += basePrice;

  var addCharges = 0;
  if (bookingData.trainingOptions.additionalCharges) {
    addCharges = Number(bookingData.trainingOptions.additionalCharges) || 0;
  }
  originalTotal += addCharges;
  total += addCharges;

  return { originalPrice: originalTotal, discountedPrice: total };
};

export default TrainingBookingCalculator;
